/**
 * Hook for managing expandable row state
 */

import { useState, useCallback, useEffect } from "react";

/**
 * Manage expandable row state for hierarchical tables
 * @param {any} resetDependency - Value that triggers reset when changed
 * @returns {Object} Expand state and handlers
 */
export const useExpandable = (resetDependency = null) => {
  const [expandedL1, setExpandedL1] = useState({});
  const [expandedL2, setExpandedL2] = useState({});

  // Reset expanded state when dependency changes
  useEffect(() => {
    if (resetDependency !== null) {
      setExpandedL1({});
      setExpandedL2({});
    }
  }, [resetDependency]);

  const toggleExpandL1 = useCallback((key) => {
    setExpandedL1((prev) => ({ ...prev, [key]: !prev[key] }));
  }, []);

  const toggleExpandL2 = useCallback((key) => {
    setExpandedL2((prev) => ({ ...prev, [key]: !prev[key] }));
  }, []);

  const isExpandedL1 = useCallback(
    (key) => Boolean(expandedL1[key]),
    [expandedL1]
  );
  const isExpandedL2 = useCallback(
    (key) => Boolean(expandedL2[key]),
    [expandedL2]
  );

  return {
    expandedL1,
    expandedL2,
    toggleExpandL1,
    toggleExpandL2,
    isExpandedL1,
    isExpandedL2,
  };
};
